import BootstrapField from '../utility/BootstrapField';
import IsEqual from 'lodash.isequal';

// import CloneDeep from 'lodash.clonedeep';
import LaneClosureRequestBlock from '../models/LaneClosureRequestBlock';
import LaneClosureRequestPresetBlock from '../models/LaneClosureRequestPresetBlock';
import LaneClosureRequestMessage from '../models/LaneClosureRequestMessage';
import LaneClosureRequestPresetLane from '../models/LaneClosureRequestPresetLane';
import LaneClosureRequestPresetRestriction from '../models/LaneClosureRequestPresetRestriction';
import LaneClosureRequestPresetSidewalk from '../models/LaneClosureRequestPresetSidewalk';
import LaneClosureRequestPresetBicycle from '../models/LaneClosureRequestPresetBicycle';
import Contravention from '../models/Contravention';
import Attachment from '../models/Attachment';


// As private as it gets.
let originalLaneClosureRequestData = null;

export default class LaneClosureRequest {

	// this will be populated from the selected requester's organization.
	static get requesterProjectIdOptions() {
		return [
		];
	}




	static get getLcrInEffectOptions() {
		return [
			{
				id: 1,
				name: "In Effect"
			},
			{
				id: 0,
				name: "Not In Effect"
			},
		];
	}


	static get getActiveStatusIdOptions() {
		return [
			{
				id: 1,
				name: "Planned",
				filter: "planned"
			},
			{
				id: 2,
				name: "Active",
				filter: "active"
			},
			{
				id: 3,
				name: "Expired",
				filter: "expired"
			},
			{
				id: 4,
				name: "Complete",
				filter: "complete"
			}
		];
	}
	static get getLaneClosureCompletionOptions() {
		return [
			{
				id: 2,
				name: "All",
				filter: "all"
			},
			{
				id: 1,
				name: "Completed",
				filter: "completed"
			},
			{
				id: 0,
				name: "Not Completed",
				filter: "notcompleted"
			}
		];
	}

	static get getApprovalStatusIdOptions() {
		return [
			{
				id: 1,
				name: "Pending",
				filter: "pending"
			},
			{
				id: 2,
				name: "Approved",
				filter: "approved"
			},
			{
				id: 3,
				name: "Denied",
				filter: "denied"
			}
		];
	}


	static get getCompleteTypeIdOptions() {
		/*
		// Pending isn't used
		{
			id: 1,
			name: "Pending",
			filter: "pending"
		},
		*/
		return [
			{
				id: 2,
				name: "Approved",
				filter: "approved"
			},
			{
				id: 3,
				name: "Denied",
				filter: "denied"
			},
			{
				id: 4,
				name: "Cancelled",
				filter: "cancelled"
			}
		];
	}

	static get getNotificationTypeIdOptions() {
		return [
			{
				id: "contravention-new-message",
				name: "Violation - New Message",
				color: 'grey'
			},
			{
				id: "contravention-updated",
				name: "Updated Violation",
				color: 'grey'
			},
			{
				id: "lc-closed",
				name: "Lanes Reported Closed",
				color: 'grey'
			},
			{
				id: "lc-not-closed",
				name: "Report lanes closed by {2} on {1}",
				color: 'grey'
			},
			{
				id: "lc-not-opened",
				name: "Report lanes re-opened by {4} on {3}. [ {7} ]",
				color: 'red'
			},
			{
				id: "lc-opened",
				name: "Lanes Reported Re-opened",
				color: 'grey'
			},
			{
				id: "lc-r-not-removed",
				name: "Lanes and Restrictions Not Reported Opened by {4} on {3}. [{6} minutes late] ",
				color: 'red'
			},
			{
				id: "lc-r-reminder-closed",
				name: "Reminder: Closures and Restrictions",
				color: 'orange'
			},
			{
				id: "lc-r-reminder-opened",
				name: "Reminder: Re-Open Lanes and Restrictions",
				color: 'orange'
			},
			{
				id: "lc-reminder-close",
				name: "Reminder: Close lanes by {2} on {1}",
				color: 'orange'
			},
			{
				id: "lc-reminder-open",
				name: "Reminder: Re-open lanes by {4} on {3}",
				color: 'orange'
			},
			{
				id: "lcr-approved",
				name: "Approved Lane Closure Request",
				color: 'green'
			},
			{
				id: "lcr-cancelled",
				name: "Cancelled Lane Closure Request",
				color: 'red'
			},
			{
				id: "lcr-completed",
				name: "Completed Lane Closure Request",
				color: 'grey'
			},
			{
				id: "lcr-new-message",
				name: "New Message",
				color: 'grey'
			},
			{
				id: "lcr-denied",
				name: "Rejected Lane Closure Request",
				color: 'red'
			},
			{
				id: "lcr-updated",
				name: "Updated Lane Closure Request",
				color: 'grey'
			},
			{
				id: "new-contravention",
				name: "New Violation",
				color: 'red'
			},
			{
				id: "new-lcr",
				name: "New Lane Closure Request",
				color: 'grey'
			},
			{
				id: "new-message",
				name: "New Message",
				color: 'grey'
			},
			{
				id: "r-not-placed",
				name: "Report restrictions placed by {2} on {1}.  [ {6} ]",
				color: 'red'
			},
			{
				id: "r-not-removed",
				name: "Report restrictions removed by {4} on {3}. [ {7} ]",
				color: 'red'
			},
			{
				id: "r-placed",
				name: "Restriction reported as placed",
				color: 'grey'
			},
			{
				id: "r-reminder-place",
				name: "Reminder: Report restrictions placed by {2} on {1}",
				color: 'orange'
			},
			{
				id: "r-reminder-remove",
				name: "Reminder: Report restrictions removed by {4} on {3}",
				color: 'orange'
			},
			{
				id: "r-removed",
				name: "Restriction reported as removed",
				color: 'grey'
			},
			{
				id: "lc-reminder-open",
				name: "Reminder: Re-open Lanes by {4} on {3}",
				color: 'orange'
			},
			{
				id: "lc-reminder-close",
				name: "Reminder: Close lanes by {2} on {1}",
				color: 'orange'
			},
			{
				id: "lcr-change-request",
				name: "Change requested for approved lane closure request.",
				color: 'red'
			},
			{
				id: "lcr-status-updated",
				name: "Lane Closure Request Status Updated",
				color: 'orange'
			}

	];
	}



	// only used for requested changes to a lane closure request.
	static get getChangeStatusIdOptions() {
		return [
			{
				id: 1,
				name: "Pending"
			},
			{
				id: 2,
				name: "Approved"
			},
			{
				id: 3,
				name: "Denied"
			}
		];
	}

	static get getLaneClosureRequestRecordStatusIdOptions() {
		return [
			{
				id: 1,
				name: "Draft"
			},
			{
				id: 2,
				name: "New"
			},
			{
				id: 3,
				name: "Under Review"
			},
			{
				id: 4,
				name: "Waiting"
			},
			{
				id: 5,
				name: "Approved"
			},
			{
				id: 6,
				name: "Expired"
			},
			{
				id: 7,
				name: "Complete"
			}
		];
	}

	static get getFilterLaneClosureRequestRecordStatusIdOptions() {
		return [
			{
				id: null,
				name: "Status"
			},
			{
				id: 2,
				name: "New"
			},
			{
				id: 3,
				name: "Under Review"
			},
			{
				id: 4,
				name: "Waiting"
			},
			{
				id: 5,
				name: "Approved"
			},
			{
				id: 6,
				name: "Expired"
			},
			{
				id: 7,
				name: "Complete"
			}
		];
	}


	static get getFilterLaneClosureRequestRecordStatusIdOptionsMobile() {
		return [
			{
				id: null,
				name: "Any Status"
			},
			{
				id: 2,
				name: "New"
			},
			{
				id: 3,
				name: "Under Review"
			},
			{
				id: 4,
				name: "Waiting"
			},
			{
				id: 5,
				name: "Approved"
			},
			{
				id: 6,
				name: "Expired"
			},
			{
				id: 7,
				name: "Complete"
			}
		];
	}


	static get getFilterMineOptions() {
		return [
			{
				id: 1,
				name: "My Requests"
			},
			{
				id: 0,
				name: "All Requests"
			},
		];
	}


	// this is for reported lane closures
	static get getLaneClosureRecordStatusIdOptions() {
		return [
			{
				id: 1,
				name: "Planned",
				filter: "planned"
			},
			{
				id: 2,
				name: "Active",
				filter: "active"
			},
			{
				id: 3,
				name: "Expired",
				filter: "expired"
			},
			{
				id: 4,
				name: "Complete",
				filter: "complete"
			},
		];
	}

	// this is for reported restrictions.
	static get getRestrictionRecordStatusIdOptions() {
		return [
			{
				id: 1,
				name: "Draft"
			},
			{
				id: 2,
				name: "Planned"
			},
			{
				id: 3,
				name: "Active"
			},
			{
				id: 4,
				name: "Expired - Unknown"
			},
			{
				id: 5,
				name: "Complete"
			},
			{
				id: 6,
				name: "Cancelled"
			},
		];
	}

	static get getBicycleLaneOptions() {
		return [
			{
				id: 1,
				name: "Eastbound painted bike lane",
				img: "/img/lcr/bicycle.png",
				imgLight: "/img/lcr/light/bicycle.png",
				img100: "/img/100x100/dark/bicycle.png",
				imgLight100: "/img/100x100/light/bicycle.png",
				directionIds: [3, 4, 5]
			},
			{
				id: 2,
				name: "Eastbound protected bike lane",
				img: "/img/lcr/bicycle.png",
				imgLight: "/img/lcr/light/bicycle.png",
				img100: "/img/100x100/dark/bicycle.png",
				imgLight100: "/img/100x100/light/bicycle.png",
				directionIds: [3, 4, 5]
			},
			{
				id: 9,
				name: "Eastbound painted and protected bike lane",
				img: "/img/lcr/bicycle.png",
				imgLight: "/img/lcr/light/bicycle.png",
				img100: "/img/100x100/dark/bicycle.png",
				imgLight100: "/img/100x100/light/bicycle.png",
				directionIds: [3, 4, 5]
			},
			{
				id: 3,
				name: "Westbound painted bike lane",
				img: "/img/lcr/bicycle.png",
				imgLight: "/img/lcr/light/bicycle.png",
				img100: "/img/100x100/dark/bicycle.png",
				imgLight100: "/img/100x100/light/bicycle.png",
				directionIds: [3, 4, 5]
			},
			{
				id: 4,
				name: "Westbound protected bike lane",
				img: "/img/lcr/bicycle.png",
				imgLight: "/img/lcr/light/bicycle.png",
				img100: "/img/100x100/dark/bicycle.png",
				imgLight100: "/img/100x100/light/bicycle.png",
				directionIds: [3, 4, 5]

			},
			{
				id: 10,
				name: "Westbound painted and protected bike lane",
				img: "/img/lcr/bicycle.png",
				imgLight: "/img/lcr/light/bicycle.png",
				img100: "/img/100x100/dark/bicycle.png",
				imgLight100: "/img/100x100/light/bicycle.png",
				directionIds: [3, 4, 5]

			},
			{
				id: 5,
				name: "Northbound painted bike lane",
				img: "/img/lcr/bicycle.png",
				imgLight: "/img/lcr/light/bicycle.png",
				img100: "/img/100x100/dark/bicycle.png",
				imgLight100: "/img/100x100/light/bicycle.png",
				directionIds: [1, 2, 6]
			},
			{
				id: 6,
				name: "Northbound protected bike lane",
				img: "/img/lcr/bicycle.png",
				imgLight: "/img/lcr/light/bicycle.png",
				img100: "/img/100x100/dark/bicycle.png",
				imgLight100: "/img/100x100/light/bicycle.png",
				directionIds: [1, 2, 6]
			},
			{
				id: 11,
				name: "Northbound painted and protected bike lane",
				img: "/img/lcr/bicycle.png",
				imgLight: "/img/lcr/light/bicycle.png",
				img100: "/img/100x100/dark/bicycle.png",
				imgLight100: "/img/100x100/light/bicycle.png",
				directionIds: [1, 2, 6]
			},
			{
				id: 7,
				name: "Southbound painted bike lane",
				img: "/img/lcr/bicycle.png",
				imgLight: "/img/lcr/light/bicycle.png",
				img100: "/img/100x100/dark/bicycle.png",
				imgLight100: "/img/100x100/light/bicycle.png",
				directionIds: [1, 2, 6]
			},
			{
				id: 8,
				name: "Southbound protected bike lane",
				img: "/img/lcr/bicycle.png",
				imgLight: "/img/lcr/light/bicycle.png",
				img100: "/img/100x100/dark/bicycle.png",
				imgLight100: "/img/100x100/light/bicycle.png",
				directionIds: [1, 2, 6]
			},
			{
				id: 13,
				name: "Southbound painted and protected bike lane",
				img: "/img/lcr/bicycle.png",
				imgLight: "/img/lcr/light/bicycle.png",
				img100: "/img/100x100/dark/bicycle.png",
				imgLight100: "/img/100x100/light/bicycle.png",
				directionIds: [1, 2, 6]
		},
		];
	}

	static isProtectedBikeLane(bicycleLaneId) {
		if (bicycleLaneId == 2 || bicycleLaneId == 4 || bicycleLaneId == 6 || bicycleLaneId == 8 || bicycleLaneId == 9 || bicycleLaneId == 10 || bicycleLaneId == 11 || bicycleLaneId == 13) {
			return true;
		}
		return false;
	}

	static getDirectionalBicycleLaneOptions(directionId) {
		var options = [];

		if (directionId == 3 || directionId == 4 || directionId == 5 || directionId == null) {
			options.push({
				id: 1,
				name: "Eastbound painted bike lane",
				img: "/img/lcr/bicycle.png",
				imgLight: "/img/lcr/light/bicycle.png",
				directionIds: [3, 4, 5]
			});
			options.push({
				id: 2,
				name: "Eastbound protected bike lane",
				img: "/img/lcr/bicycle.png",
				imgLight: "/img/lcr/light/bicycle.png",
				directionIds: [3, 4, 5]
			});
			options.push({
				id: 9,
				name: "Eastbound painted and protected bike lane",
				img: "/img/lcr/bicycle.png",
				imgLight: "/img/lcr/light/bicycle.png",
				directionIds: [3, 4, 5]
			})
			options.push({
				id: 3,
				name: "Westbound painted bike lane",
				img: "/img/lcr/bicycle.png",
				imgLight: "/img/lcr/light/bicycle.png",
				directionIds: [3, 4, 5]
			});

			options.push({
				id: 4,
				name: "Westbound protected bike lane",
				img: "/img/lcr/bicycle.png",
				imgLight: "/img/lcr/light/bicycle.png",
				directionIds: [3, 4, 5]
			});

			options.push({
				id: 4,
				name: "Westbound protected bike lane",
				img: "/img/lcr/bicycle.png",
				imgLight: "/img/lcr/light/bicycle.png",
				directionIds: [3, 4, 5]

			});
		}

		if (directionId == 1 || directionId == 2 || directionId == 6 || directionId == null) {

			options.push({
				id: 5,
				name: "Northbound painted bike lane",
				img: "/img/lcr/bicycle.png",
				imgLight: "/img/lcr/light/bicycle.png",
				directionIds: [1, 2, 6]
			});
			options.push({
				id: 6,
				name: "Northbound protected bike lane",
				img: "/img/lcr/bicycle.png",
				imgLight: "/img/lcr/light/bicycle.png",
				directionIds: [1, 2, 6]
			});
			options.push({
				id: 11,
				name: "Northbound painted and protected bike lane",
				img: "/img/lcr/bicycle.png",
				imgLight: "/img/lcr/light/bicycle.png",
				directionIds: [1, 2, 6]
			});
			options.push({
				id: 7,
				name: "Southbound painted bike lane",
				img: "/img/lcr/bicycle.png",
				imgLight: "/img/lcr/light/bicycle.png",
				directionIds: [1, 2, 6]
			});
			options.push({
				id: 8,
				name: "Southbound protected bike lane",
				img: "/img/lcr/bicycle.png",
				imgLight: "/img/lcr/light/bicycle.png",
				directionIds: [1, 2, 6]
			});
			options.push({
				id: 13,
				name: "Southbound painted and protected bike lane",
				img: "/img/lcr/bicycle.png",
				imgLight: "/img/lcr/light/bicycle.png",
				directionIds: [1, 2, 6]
			});
		}
		return options;
	}


	static get getEastboundBicycleLaneOptions() {
		return [
			{
				id: null,
				name: "No Bicycle Lane",
				img: "/img/lcr/bicycle.png",
				imgLight: "/img/lcr/light/bicycle.png",
			},
			{
				id: 1,
				name: "Painted bike lane",
				img: "/img/lcr/bicycle.png",
				imgLight: "/img/lcr/light/bicycle.png",
			},
			{
				id: 2,
				name: "Protected bike lane",
				img: "/img/lcr/bicycle.png",
				imgLight: "/img/lcr/light/bicycle.png",
			},
			{
				id: 9,
				name: "Painted and Protected bike lane",
				img: "/img/lcr/bicycle.png",
				imgLight: "/img/lcr/light/bicycle.png",
			},
		];
	}

	static get getWestboundBicycleLaneOptions() {
		return [
			{
				id: null,
				name: "No Bicycle Lane",
				img: "/img/lcr/bicycle.png",
				imgLight: "/img/lcr/light/bicycle.png",
			},
			{
				id: 3,
				name: "Painted bike lane",
				img: "/img/lcr/bicycle.png",
				imgLight: "/img/lcr/light/bicycle.png",
			},
			{
				id: 4,
				name: "Protected bike lane",
				img: "/img/lcr/bicycle.png",
				imgLight: "/img/lcr/light/bicycle.png",
			},
			{
				id: 10,
				name: "Painted and Protected bike lane",
				img: "/img/lcr/bicycle.png",
				imgLight: "/img/lcr/light/bicycle.png",
			},
		];
	}


	static get getSouthboundBicycleLaneOptions() {
		return [
			{
				id: null,
				name: "No Bicycle Lane",
				img: "/img/lcr/bicycle.png",
				imgLight: "/img/lcr/light/bicycle.png",
			},
			{
				id: 7,
				name: "Painted bike lane",
				img: "/img/lcr/bicycle.png",
				imgLight: "/img/lcr/light/bicycle.png",
			},
			{
				id: 8,
				name: "Protected bike lane",
				img: "/img/lcr/bicycle.png",
				imgLight: "/img/lcr/light/bicycle.png",
			},
			{
				id: 12,
				name: "Painted and Protected bike lane",
				img: "/img/lcr/bicycle.png",
				imgLight: "/img/lcr/light/bicycle.png",
			},
		];
	}

	static get getNorthboundBicycleLaneOptions() {
		return [
			{
				id: null,
				name: "No Bicycle Lane",
				img: "/img/lcr/bicycle.png",
				imgLight: "/img/lcr/light/bicycle.png",
			},
			{
				id: 5,
				name: "Painted bike lane",
				img: "/img/lcr/bicycle.png",
				imgLight: "/img/lcr/light/bicycle.png",
			},
			{
				id: 6,
				name: "Protected bike lane",
				img: "/img/lcr/bicycle.png",
				imgLight: "/img/lcr/light/bicycle.png",
			},
			{
				id: 11,
				name: "Painted and Protected bike lane",
				img: "/img/lcr/bicycle.png",
				imgLight: "/img/lcr/light/bicycle.png",
			},
		];
	}



	static get getDirectionIdOptions() {
		return [
			{
				id: null,
				name: "Select a Direction",
				disabled: true,
			},
			{
				id: 1,
				name: "Northbound",
				abbrev: "NB"
			},
			{
				id: 2,
				name: "Southbound",
				abbrev: "SB"
			},
			{
				id: 3,
				name: "Eastbound",
				abbrev: "EB"
			},
			{
				id: 4,
				name: "Westbound",
				abbrev: "WB"
			},
			{
				id: 5,
				name: "Eastbound & Westbound",
				abbrev: "EB & WB"
			},
			{
				id: 6,
				name: "Northbound & Southbound",
				abbrev: "NB & SB"
			}
		];
	}

	static get getRestrictionDirectionIdOptions() {
		return [
			{
				id: 1,
				name: "Northbound"
			},
			{
				id: 2,
				name: "Southbound"
			},
			{
				id: 3,
				name: "Eastbound"
			},
			{
				id: 4,
				name: "Westbound"
			},
		];
	}
	static getDirectionalRestrictionDirectionIdOptions(directionId) {
		var options = [];
		if (directionId == 1 || directionId == 2 || directionId == 6 || directionId == null) {
			options.push({
				id: 1,
				name: "Northbound"
			});
			options.push({
				id: 2,
				name: "Southbound"
			});
		}
		if (directionId == 3 || directionId == 4 || directionId == 5 || directionId == null) {
			options.push({
				id: 3,
				name: "Eastbound"
			});
			options.push({
				id: 4,
				name: "Westbound"
			});
		}
		return options;
	}


	static areDirectionsEquivalent(source, dest) {
		if (
			(source == dest) ||
			((source == 1 || source == 2 || source == null) && (dest == 6 || dest == null)) ||
			((dest == 1 || dest == 2 || dest == null) && (source == 6 || source == null))
		) {
			return true;
		}
		if (
			((source == 3 || source == 4 || source == null) && (dest == 5 || dest == null)) ||
			((dest == 3 || dest == 4 || dest == null) && (source == 5 || source == null))
		) {
			return true;
		}
		return false;
	}




	static get getClosurePeakReason() {
		return [
			{
				label: 'Both peak periods (07:00-09:00 & 15:00-18:00)',
				options: [
					{
						id: 1,
						name: 'Re-open for both peak periods. (07:00-09:00 & 15:00-18:00)',
						effect: 'will be open for morning and afternoon rush hours.'
			},
					{
						id: 2,
						name: 'Closed during both peak periods due to non plate-able open excavations.',
						effect: null
			},
					{
						id: 3,
						name: 'Closed during both peak periods because concrete will not dry in time to reopen lane(s).',
						effect: null
			},
					{
						id: 4,
						name: 'Closed during both peak periods due to long term construction impacts to the road surface',
						effect: null
			},
					{
						id: 5,
						name: 'Closed during both peak periods for a Special Event or Film production.',
						effect: null
			},
					{
						id: 6,
						name: 'Closed during both peak periods due to the nature of the work requiring extended time.',
						effect: null
			}
			]
			},
			{
				label: 'Morning peak period (07:00-09:00)',
				options: [
					{
						id: 8,
						name: 'Re-open for morning peak period. (07:00-09:00)',
						effect: 'will be open for morning rush hour.'
			},
					{
						id: 9,
						name: 'Closed during morning peak period due to non plate-able open excavations. (07:00-09:00)',
						effect: null
			},
					{
						id: 10,
						name: 'Closed during morning peak period because concrete will not dry in time to reopen lane(s). (07:00-09:00)',
						effect: null
			},
					{
						id: 11,
						name: 'Closed during morning peak period due to long term construction impacts to the road surface. (07:00-09:00)',
						effect: null
			},
					{
						id: 12,
						name: 'Closed during morning peak period for a Special Event or Film production. (07:00-09:00)',
						effect: null
			},
					{
						id: 13,
						name: 'Closed during morning peak period due to the nature of the work requiring extended time. (07:00-09:00)',
						effect: null
			},
			]
			},
			{
				label: 'Afternoon peak period (15:00-18:00)',
				options: [
					{
						id: 14,
						name: 'Re-open for afternoon peak period. (15:00-18:00)',
						effect: 'will be open for afternoon rush hour.'
			},
					{
						id: 15,
						name: 'Closed during afternoon peak period due to non plate-able open excavations. (15:00-18:00)',
						effect: null
			},
					{
						id: 16,
						name: 'Closed during afternoon peak period because concrete will not dry in time to reopen lane(s). (15:00-18:00)',
						effect: null
			},
					{
						id: 17,
						name: 'Closed during afternoon peak period due to long term construction impacts to the road surface. (15:00-18:00)',
						effect: null
			},
					{
						id: 18,
						name: 'Closed during afternoon peak period for a Special Event or Film production. (15:00-18:00)',
						effect: null
			},
					{
						id: 19,
						name: 'Closed during afternoon peak period due to the nature of the work requiring extended time. (15:00-18:00)',
						effect: null
			}
			]
			}
			];
	}


	static get getRestrictionPeakReason() {
		return [
			{
				label: 'Both peak periods (07:00-09:00 & 15:00-18:00)',
				options: [
					{
						id: 1,
						name: 'Restriction removed for peak periods. (07:00-09:00 & 15:00-18:00)'
			},
					{
						id: 2,
						name: 'In-effect during peak periods due to non plate-able open excavations.'
			},
					{
						id: 3,
						name: 'In-effect during peak periods concrete will not dry in time.'
			},
					{
						id: 4,
						name: 'In-effect during peak periods due to long term construction impacts to the road surface'
			},
					{
						id: 5,
						name: 'In-effect during peak periods because of Special Event or Film production.'
			},
					{
						id: 6,
						name: 'In-effect during peak periods due to the nature of the work requiring extended time.'
			},
			]
		},
			{
				label: 'Morning peak period (07:00-09:00)',
				options: [
					{
						id: 8,
						name: 'Removed for morning peak period. (07:00-09:00)'
			},
					{
						id: 9,
						name: 'In-effect during morning peak period due to non plate-able open excavations. (07:00-09:00)'
			},
					{
						id: 10,
						name: 'In-effect during morning peak period because concrete will not dry in time to reopen lane(s). (07:00-09:00)'
			},
					{
						id: 11,
						name: 'In-effect during morning peak period due to long term construction impacts to the road surface. (07:00-09:00)'
			},
					{
						id: 12,
						name: 'In-effect during morning peak period for a Special Event or Film production. (07:00-09:00)'
			},
					{
						id: 13,
						name: 'In-effect during morning peak period due to the nature of the work requiring extended time. (07:00-09:00)'
			},
			]
			},
			{
				label: 'Afternoon peak period (15:00-18:00)',
				options: [
					{
						id: 14,
						name: 'Removed for afternoon peak period. (15:00-18:00)'
			},
					{
						id: 15,
						name: 'In-effect during afternoon peak period due to non plate-able open excavations. (15:00-18:00)'
			},
					{
						id: 16,
						name: 'In-effect during afternoon peak period because concrete will not dry in time to reopen lane(s). (15:00-18:00)'
			},
					{
						id: 17,
						name: 'In-effect during afternoon peak period due to long term construction impacts to the road surface. (15:00-18:00)'
			},
					{
						id: 18,
						name: 'In-effect during afternoon peak period for a Special Event or Film production. (15:00-18:00)'
			},
					{
						id: 19,
						name: 'In-effect during afternoon peak period due to the nature of the work requiring extended time. (15:00-18:00)'
			}
			]
			},

				];
	}

	static get getClosurePeakReasonShort() {
		return [
			{
				text: "Reopen for both peak periods.",
				ids: [1],
			},
			{
				text: "Reopen for morning peak period.",
				ids: [8],
			},
			{
				text: "Reopen for afternoon peak period.",
				ids: [14],
			},
			{
				text: "Closed for both peak periods.",
				ids: [2,3,4,5,6],
			},
			{
				text: "Closed for morning peak period.",
				ids: [9,10,11,12,13]
			},
			{
				text: "Closed for afternoon peak period.",
				ids: [15,16,17,18,19]
			}
		];
	}

	static get getRestrictionPeakReasonShort() {
		return [
			{
				text: "Removed for both peak periods.",
				ids: [1],
			},
			{
				text: "Removed for morning peak period.",
				ids: [8],
			},
			{
				text: "Removed for afternoon peak period.",
				ids: [14],
			},
			{
				text: "In-effect for both peak periods.",
				ids: [2,3,4,5,6],
			},
			{
				text: "In-effect for morning peak period.",
				ids: [9,10,11,12,13]
			},
			{
				text: "In-effect for afternoon peak period.",
				ids: [15,16,17,18,19]
			}
		];
	}

	static getRestrictionPeakIdText(id) {
		if (id) {
			let entry = this.searchByGroupedId(id, this.getRestrictionPeakReason);
			if (entry) {
				return entry.name;
			}

		}
		return null;
	}

	static getApprovalStatusIdText(id) {
		if (id) {
			let entry = this.searchById(id, this.getApprovalStatusIdOptions);
			if (entry) {
				return entry.name;
			}

		}
		return null;
	}
	static getCompleteTypeIdText(id) {
		if (id) {
			return this.searchById(id, this.getCompleteTypeIdOptions).name;
		}
		return null;
	}

	static getLcrInEffectText(id) {
		if (typeof id == "number") {
			return this.searchById(id, this.getLcrInEffectOptions).name;
		}
		return null;
	}




	static get getTurningRestrictionLaneOptions() {
		return [
			{
				id: 19,
				name: 'Eastbound right turn (yield) lane'
			},
			{
				id: 1,
				name: 'Eastbound curb lane'
			},
			{
				id: 2,
				name: 'Eastbound middle lane'
			},
			{
				id: 24,
				name: 'Eastbound middle lane 2'
			},
			{
				id: 25,
				name: 'Eastbound middle lane 3'
			},
			{
				id: 3,
				name: 'Eastbound median lane'
			},
			{
				id: 15,
				name: 'Eastbound left turn storage lane'
			},
			{
				id: 32,
				name: 'Eastbound left turn storage lane 2'
			},
			{
				id: 33,
				name: 'Eastbound left turn storage lane 3'
			},
			{
				id: 44,
				name: 'Eastbound shoulder lane'
			},
			{
				id: 20,
				name: 'Westbound right turn (yield) lane'
			},
			{
				id: 4,
				name: 'Westbound curb lane'
			},
			{
				id: 5,
				name: 'Westbound middle lane'
			},
			{
				id: 26,
				name: 'Westbound middle lane 2'
			},
			{
				id: 27,
				name: 'Westbound middle lane 3'
			},
			{
				id: 6,
				name: 'Westbound median lane'
			},
			{
				id: 16,
				name: 'Westbound left turn storage lane'
			},
			{
				id: 34,
				name: 'Westbound left turn storage lane 2'
			},
			{
				id: 35,
				name: 'Westbound left turn storage lane 3'
			},
			{
				id: 21,
				name: 'Northbound right turn (yield) lane'
			},
			{
				id: 45,
				name: 'Westbound shoulder lane'
			},
			{
				id: 7,
				name: 'Northbound curb lane'
			},
			{
				id: 8,
				name: 'Northbound middle lane'
			},
			{
				id: 28,
				name: 'Northbound middle lane 2'
			},
			{
				id: 29,
				name: 'Northbound middle lane 3'
			},
			{
				id: 9,
				name: 'Northbound median lane'
			},
			{
				id: 17,
				name: 'Northbound left turn storage lane'
			},
			{
				id: 36,
				name: 'Northbound left turn storage lane 2'
			},
			{
				id: 37,
				name: 'Northbound left turn storage lane 3'
			},
			{
				id: 46,
				name: 'Northbound shoulder lane'
			},
			{
				id: 22,
				name: 'Southbound right turn (yield) lane'
			},
			{
				id: 10,
				name: 'Southbound curb lane'
			},
			{
				id: 11,
				name: 'Southbound middle lane'
			},
			{
				id: 30,
				name: 'Southbound middle lane 2'
			},
			{
				id: 31,
				name: 'Southbound middle lane 3'
			},
			{
				id: 12,
				name: 'Southbound median lane'
			},
			{
				id: 18,
				name: 'Southbound left turn storage lane'
			},
			{
				id: 38,
				name: 'Southbound left turn storage lane 2'
			},
			{
				id: 39,
				name: 'Southbound left turn storage lane 3'
			},
			{
				id: 47,
				name: 'Southbound shoulder lane'
			},
			{
				id: 23,
				name: 'Back lane/Public lane'
			}

		];
	}

	// this is for reported lane closures
	static get getTurningRestrictionTypeOptions() {
		return [
			{
				id: 1,
				name: "No Left Turn",
				img: "/img/lcr/no-left-turn.png",
				imgLight: "/img/lcr/light/no-left-turn.png",
				img100: "/img/100x100/dark/no-left-turn.png",
				imgLight100: "/img/100x100/light/no-left-turn.png",
			},
			{
				id: 2,
				name: "No Right Turn",
				img: "/img/lcr/no-right-turn.png",
				imgLight: "/img/lcr/light/no-right-turn.png",
				img100: "/img/100x100/dark/no-right-turn.png",
				imgLight100: "/img/100x100/light/no-right-turn.png",
			},
			{
				id: 3,
				name: "No Through",
				img: "/img/lcr/no-through.png",
				imgLight: "/img/lcr/light/no-through.png",
				img100: "/img/100x100/dark/no-through.png",
				imgLight100: "/img/100x100/light/no-through.png",
			},
		];
	}



	static get getLaneAffectedOptions() {
		return [
			{
				label: "Eastbound",
				options: [
					{
						id: 1,
						name: 'Eastbound curb lane (or right side curb for a one-way)',
						effect: 'Eastbound curb lane',
						img: '/img/lcr/eastbound-lane.svg',
						img100: '/img/100x100/dark/eastbound.png',
						directionIds: [3, 5]
			},
					{
						id: 2,
						name: 'Eastbound middle lane',
						effect: 'Eastbound middle lane',
						img: '/img/lcr/eastbound-lane.svg',
						img100: '/img/100x100/dark/eastbound.png',
						directionIds: [3, 5]
			},
					{
						id: 24,
						name: 'Eastbound middle lane 2',
						effect: 'Eastbound middle lane 2',
						img: '/img/lcr/eastbound-lane.svg',
						img100: '/img/100x100/dark/eastbound.png',
						directionIds: [3, 5]
			},
					{
						id: 25,
						name: 'Eastbound middle lane 3',
						effect: 'Eastbound middle lane 3',
						img: '/img/lcr/eastbound-lane.svg',
						img100: '/img/100x100/dark/eastbound.png',
						directionIds: [3, 5]
			},
					{
						id: 3,
						name: 'Eastbound median lane (or left side curb for a one-way)',
						effect: 'Eastbound median lane',
						img: '/img/lcr/eastbound-lane.svg',
						img100: '/img/100x100/dark/eastbound.png',
						directionIds: [3, 5]
			},
					{
						id: 15,
						name: 'Eastbound left turn storage lane',
						effect: 'Eastbound left turn storage lane',
						img: '/img/lcr/eastbound-lane.svg',
						img100: '/img/100x100/dark/eastbound.png',
						directionIds: [3, 5]
			},
					{
						id: 32,
						name: 'Eastbound left turn storage lane 2',
						effect: 'Eastbound left turn storage lane 2',
						img: '/img/lcr/eastbound-lane.svg',
						img100: '/img/100x100/dark/eastbound.png',
						directionIds: [3, 5]
			},
					{
						id: 33,
						name: 'Eastbound left turn storage lane 3',
						effect: 'Eastbound left turn storage lane 3',
						img: '/img/lcr/eastbound-lane.svg',
						img100: '/img/100x100/dark/eastbound.png',
						directionIds: [3, 5]
			},
					{
						id: 19,
						name: 'Eastbound right turn (yield) lane',
						effect: 'Eastbound right turn (yield) lane',
						img: '/img/lcr/eastbound-lane.svg',
						img100: '/img/100x100/dark/eastbound.png',
						directionIds: [3, 5]
			},
					{
						id: 44,
						name: 'Eastbound shoulder lane',
						effect: 'Eastbound shoulder lane',
						img: '/img/lcr/eastbound-lane.svg',
						img100: '/img/100x100/dark/eastbound.png',
						directionIds: [3, 5]
			},
					{
						id: 40,
						name: 'Complete closure of all Eastbound lanes',
						effect: 'Complete closure of all Eastbound lanes',
						img: '/img/lcr/eastbound-lane.svg',
						img100: '/img/100x100/dark/eastbound.png',
						directionIds: [3, 5]
			},
			]
			},
			{
				label: "Westbound",
				options: [
					{
						id: 4,
						name: 'Westbound curb lane (or right side curb for a one-way)',
						effect: 'Westbound curb lane',
						img: '/img/lcr/westbound-lane.svg',
						img100: '/img/100x100/dark/westbound.png',
						directionIds: [4, 5]
			},
					{
						id: 5,
						name: 'Westbound middle lane',
						effect: 'Westbound middle lane',
						img: '/img/lcr/westbound-lane.svg',
						img100: '/img/100x100/dark/westbound.png',
						directionIds: [4, 5]
			},
					{
						id: 26,
						name: 'Westbound middle lane 2',
						effect: 'Westbound middle lane 2',
						img: '/img/lcr/westbound-lane.svg',
						img100: '/img/100x100/dark/westbound.png',
						directionIds: [4, 5]
			},
					{
						id: 27,
						name: 'Westbound middle lane 3',
						effect: 'Westbound middle lane 3',
						img: '/img/lcr/westbound-lane.svg',
						img100: '/img/100x100/dark/westbound.png',
						directionIds: [4, 5]
			},
					{
						id: 6,
						name: 'Westbound median lane (or left side curb for a one-way)',
						effect: 'Westbound median lane',
						img: '/img/lcr/westbound-lane.svg',
						img100: '/img/100x100/dark/westbound.png',
						directionIds: [4, 5]
			},
					{
						id: 16,
						name: 'Westbound left turn storage lane',
						effect: 'Westbound left turn storage lane',
						img: '/img/lcr/westbound-lane.svg',
						img100: '/img/100x100/dark/westbound.png',
						directionIds: [4, 5]
			},
					{
						id: 34,
						name: 'Westbound left turn storage lane 2',
						effect: 'Westbound left turn storage lane 2',
						img: '/img/lcr/westbound-lane.svg',
						img100: '/img/100x100/dark/westbound.png',
						directionIds: [4, 5]
			},
					{
						id: 35,
						name: 'Westbound left turn storage lane 3',
						effect: 'Westbound left turn storage lane 3',
						img: '/img/lcr/westbound-lane.svg',
						img100: '/img/100x100/dark/westbound.png',
						directionIds: [4, 5]
			},
					{
						id: 20,
						name: 'Westbound right turn (yield) lane',
						effect: 'Westbound right turn (yield) lane',
						img: '/img/lcr/westbound-lane.svg',
						img100: '/img/100x100/dark/westbound.png',
						directionIds: [4, 5]
			},
					{
						id: 45,
						name: 'Westbound shoulder lane',
						effect: 'Westbound shoulder lane',
						img: '/img/lcr/westbound-lane.svg',
						img100: '/img/100x100/dark/westbound.png',
						directionIds: [4, 5]
			},
					{
						id: 41,
						name: 'Complete closure of all Westbound lanes',
						effect: 'Complete closure of all Westbound lanes',
						img: '/img/lcr/westbound-lane.svg',
						img100: '/img/100x100/dark/westbound.png',
						directionIds: [4, 5]
			},
			]
			},
			{
				label: "Northbound",
				options: [
					{
						id: 7,
						name: 'Northbound curb lane (or right side curb for a one-way)',
						effect: 'Northbound curb lane',
						img: '/img/lcr/northbound-lane.svg',
						img100: '/img/100x100/dark/northbound.png',
						directionIds: [1, 6]
			},
					{
						id: 8,
						name: 'Northbound middle lane',
						effect: 'Northbound middle lane',
						img: '/img/lcr/northbound-lane.svg',
						img100: '/img/100x100/dark/northbound.png',
						directionIds: [1, 6]
			},
					{
						id: 28,
						name: 'Northbound middle lane 2',
						effect: 'Northbound middle lane 2',
						img: '/img/lcr/northbound-lane.svg',
						img100: '/img/100x100/dark/northbound.png',
						directionIds: [1, 6]
			},
					{
						id: 29,
						name: 'Northbound middle lane 3',
						effect: 'Northbound middle lane 3',
						img: '/img/lcr/northbound-lane.svg',
						img100: '/img/100x100/dark/northbound.png',
						directionIds: [1, 6]
			},
					{
						id: 9,
						name: 'Northbound median lane (or left side curb for a one-way)',
						effect: 'Northbound median lane',
						img: '/img/lcr/northbound-lane.svg',
						img100: '/img/100x100/dark/northbound.png',
						directionIds: [1, 6]
			},
					{
						id: 17,
						name: 'Northbound left turn storage lane',
						effect: 'Northbound left turn storage lane',
						img: '/img/lcr/northbound-lane.svg',
						img100: '/img/100x100/dark/northbound.png',
						directionIds: [1, 6]
			},
					{
						id: 36,
						name: 'Northbound left turn storage lane 2',
						effect: 'Northbound left turn storage lane 2',
						img: '/img/lcr/northbound-lane.svg',
						img100: '/img/100x100/dark/northbound.png',
						directionIds: [1, 6]
			},
					{
						id: 37,
						name: 'Northbound left turn storage lane 3',
						effect: 'Northbound left turn storage lane 3',
						img: '/img/lcr/northbound-lane.svg',
						img100: '/img/100x100/dark/northbound.png',
						directionIds: [1, 6]
			},
					{
						id: 21,
						name: 'Northbound right turn (yield) lane',
						effect: 'Northbound right turn (yield) lane',
						img: '/img/lcr/northbound-lane.svg',
						img100: '/img/100x100/dark/northbound.png',
						directionIds: [1, 6]
			},
					{
						id: 46,
						name: 'Northbound shoulder lane',
						effect: 'Northbound shoulder lane',
						img: '/img/lcr/northbound-lane.svg',
						img100: '/img/100x100/dark/northbound.png',
						directionIds: [1, 6]
			},
					{
						id: 42,
						name: 'Complete closure of all Northbound lanes',
						effect: 'Complete closure of all Northbound lanes',
						img: '/img/lcr/northbound-lane.svg',
						img100: '/img/100x100/dark/northbound.png',
						directionIds: [1, 6]
			},
			]
			},
			{
				label: "Southbound",
				options: [
					{
						id: 10,
						name: 'Southbound curb lane (or right side curb for a one-way)',
						effect: 'Southbound curb lane',
						img: '/img/lcr/southbound-lane.svg',
						img100: '/img/100x100/dark/southbound.png',
						directionIds: [2, 6]
			},
					{
						id: 11,
						name: 'Southbound middle lane',
						effect: 'Southbound middle lane',
						img: '/img/lcr/southbound-lane.svg',
						img100: '/img/100x100/dark/southbound.png',
						directionIds: [2, 6]
			},
					{
						id: 30,
						name: 'Southbound middle lane 2',
						effect: 'Southbound middle lane 2',
						img: '/img/lcr/southbound-lane.svg',
						img100: '/img/100x100/dark/southbound.png',
						directionIds: [2, 6]
			},
					{
						id: 31,
						name: 'Southbound middle lane 3',
						effect: 'Southbound middle lane 3',
						img: '/img/lcr/southbound-lane.svg',
						img100: '/img/100x100/dark/southbound.png',
						directionIds: [2, 6]
			},
					{
						id: 12,
						name: 'Southbound median lane (or left side curb for a one-way)',
						effect: 'Southbound median lane',
						img: '/img/lcr/southbound-lane.svg',
						img100: '/img/100x100/dark/southbound.png',
						directionIds: [2, 6]
			},
					{
						id: 22,
						name: 'Southbound right turn (yield) lane',
						effect: 'Southbound right turn (yield) lane',
						img: '/img/lcr/southbound-lane.svg',
						img100: '/img/100x100/dark/southbound.png',
						directionIds: [2, 6]
			},
					{
						id: 18,
						name: 'Southbound left turn storage lane',
						effect: 'Southbound left turn storage lane',
						img: '/img/lcr/southbound-lane.svg',
						img100: '/img/100x100/dark/southbound.png',
						directionIds: [2, 6]
			},
					{
						id: 38,
						name: 'Southbound left turn storage lane 2',
						effect: 'Southbound left turn storage lane 2',
						img: '/img/lcr/southbound-lane.svg',
						img100: '/img/100x100/dark/southbound.png',
						directionIds: [2, 6]
			},
					{
						id: 39,
						name: 'Southbound left turn storage lane 3',
						effect: 'Southbound left turn storage lane 3',
						img: '/img/lcr/southbound-lane.svg',
						img100: '/img/100x100/dark/southbound.png',
						directionIds: [2, 6]
			},
					{
						id: 47,
						name: 'Southbound shoulder lane',
						effect: 'Southbound shoulder lane',
						img: '/img/lcr/southbound-lane.svg',
						img100: '/img/100x100/dark/southbound.png',
						directionIds: [2, 6]
			},
					{
						id: 43,
						name: 'Complete closure of all Southbound lanes',
						effect: 'Complete closure of all Southbound lanes',
						img: '/img/lcr/southbound-lane.svg',
						img100: '/img/100x100/dark/southbound.png',
						directionIds: [2, 6]
			}, ]
			},
			// {
			// 	id: 13,
			// 	name: 'Complete closure of one direction',
			// 	img: '/img/lcr/closed-lane.png',
			// 	directionIds: [1, 2, 3, 4, 5, 6]
			// },
			// {
			// 	id: 14,
			// 	name: 'Complete closure of entire street',
			// 	img: '/img/lcr/closed-lane.png',
			// 	directionIds: [1, 2, 3, 4, 5, 6]
			// },
			{
				label: "Other",
				options: [
					{
						id: 23,
						name: 'Back lane/Public lane',
						effect: 'Back lane/Public lane',
						img: '/img/lcr/closed-lane.png',
						directionIds: [1, 2, 3, 4, 5, 6]
			},
			]
			}
		];
	}

	static get getNatureOfWorkOptions() {
		return [
			{
				id: null,
				name: 'Select a Primary Reason for Closure',
				disabled: true,
			},
			{
				id: 1,
				name: 'Street Construction/Maintenance',
				effect: 'street construction/maintenance'
			},
			{
				id: 2,
				name: 'Water',
				effect: 'water work'
			},
			{
				id: 3,
				name: 'Sewer',
				effect: 'sewer work'
			},
			{
				id: 4,
				name: 'Electrical/Lighting/Signals',
				effect: 'electrical/lighting/signals work'
			},
			{
				id: 5,
				name: 'Gas',
				effect: 'gas work'

			},
			{
				id: 6,
				name: 'Communications (Phone, Cable, Internet)',
				effect: 'communications work'
			},
			{
				id: 7,
				name: 'Building Construction/Maintenance',
				effect: 'building construction/maintenance'
			},
			{
				id: 8,
				name: 'Film Production or Special Event/Festival',
				effect: 'film production or special event/festival'
			},
			{
				id: 9,
				name: 'Landscaping/Tree Maintenance',
				effect: 'landscaping/tree maintenance'
			},
			{
				id: 10,
				name: 'Block Party',
				effect: 'block party'
			},
			{
				id: 11,
				name: 'Private Special Event',
				effect: 'private special event'
			},
			{
				id: 12,
				name: 'Application for an Annual Curb Lane Permit',
				effect: null
			},
			{
				id: 13,
				name: 'Conducting Business on a Boulevard Permit (Hot Dog Carts etc.)',
				effect: 'conducting business on a boulevard'
			},
			{
				id: 14,
				name: 'Loading/Unloading of Trucks/Overseas Bins/Trailers',
				effect: 'loading/unloading'
			}
		];
	}

	static get getSidewalkOptions() {
		return [
			{
				name: 'East side sidewalk',
				id: 1,
				img: "/img/lcr/sidewalk.png",
				imgLight: "/img/lcr/light/sidewalk.png",
				img100: "/img/100x100/dark/sidewalk.png",
				imgLight100: "/img/100x100/light/sidewalk.png",
				directionIds: [3, 4, 5]
			},
			{
				name: 'West side sidewalk',
				id: 2,
				img: "/img/lcr/sidewalk.png",
				imgLight: "/img/lcr/light/sidewalk.png",
				img100: "/img/100x100/dark/sidewalk.png",
				imgLight100: "/img/100x100/light/sidewalk.png",
				directionIds: [3, 4, 5]
			},
			{
				name: 'North side sidewalk',
				id: 3,
				img: "/img/lcr/sidewalk.png",
				imgLight: "/img/lcr/light/sidewalk.png",
				img100: "/img/100x100/dark/sidewalk.png",
				imgLight100: "/img/100x100/light/sidewalk.png",
				directionIds: [1, 2, 6]

			},
			{
				name: 'South side sidewalk',
				id: 4,
				img: "/img/lcr/sidewalk.png",
				imgLight: "/img/lcr/light/sidewalk.png",
				img100: "/img/100x100/dark/sidewalk.png",
				imgLight100: "/img/100x100/light/sidewalk.png",
				directionIds: [1, 2, 6]

			}
		];
	}

	static getDirectionalSidewalkOptions(directionId) {
		var options = [];

		if (directionId == 1 || directionId == 2 || directionId == 6 || directionId == null) {
			options.push({
				name: 'East side sidewalk',
				id: 1,
				img: "/img/lcr/sidewalk.png",
				directionIds: [3, 4, 5]
			});
			options.push({
				name: 'West side sidewalk',
				id: 2,
				img: "/img/lcr/sidewalk.png",
				directionIds: [3, 4, 5]
			});
		}
		if (directionId == 3 || directionId == 4 || directionId == 5 || directionId == null) {

			options.push({
				name: 'North side sidewalk',
				id: 3,
				img: "/img/lcr/sidewalk.png",
				directionIds: [1, 2, 6]
			});
			options.push({
				name: 'South side sidewalk',
				id: 4,
				img: "/img/lcr/sidewalk.png",
				directionIds: [1, 2, 6]
			});
		}
		return options;
	}


	static get getAffectTransitOptions() {
		return [
			{
				name: 'Blocking or needing to relocate bus stops',
				id: 2
			},
			{
				name: 'Blocking a Transit diamond lane',
				id: 3
			},
			{
				name: 'Transit will have to re-route service onto an alternate street',
				id: 4
			},
			{
				name: 'Other',
				id: 5
			},
		];
	}

	static get getParkingRemoveOptions() {
		return [
			{
				name: 'Yes, I require parking removed by Traffic Services',
				id: 1
			},
			{
				name: 'No, I do not require any parking removed',
				id: 2
			},
			{
				name: 'City of Winnipeg Streets and Urban Forestry staff do not require Traffic Services to remove parking. As such we will be removing our own parking.',
				id: 3
			},
			{
				name: 'City of Winnipeg Film and Special Events Office',
				id: 4
			}
			,
			{
				name: 'Authorized Construction Agency will remove parking',
				id: 5
			}
		];
	}


	static get getViewParkingRemoveOptions() {
		return [
			{
				name: 'Parking must be removed',
				id: 1
			},
			{
				name: 'Parking will NOT being removed',
				id: 2
			},
			{
				name: 'City of Winnipeg Streets and Urban Forestry staff do not require Traffic Services to remove parking. As such we will be removing our own parking.',
				id: 3
			},
			{
				name: 'City of Winnipeg Film and Special Events Office',
				id: 4
			}
		];
	}


	// These are regular lanes instead of specific parking lanes. We might as well use the same table.
	static get getParkingLaneOptions() {
		return [
			{
				id: 1,
				img: '/img/lcr/eastbound-lane.svg',
				img100: '/img/100x100/dark/eastbound.png',
				name: 'Eastbound curb lane (or right side curb for a one-way)'
			},
			{
				id: 4,
				img: '/img/lcr/westbound-lane.svg',
				img100: '/img/100x100/dark/westbound.png',
				name: 'Westbound curb lane (or right side curb for a one-way)'
			},
			{
				id: 7,
				img: '/img/lcr/northbound-lane.svg',
				img100: '/img/100x100/dark/northbound.png',
				name: 'Northbound curb lane (or right side curb for a one-way)'
			},
			{
				id: 10,
				img: '/img/lcr/southbound-lane.svg',
				img100: '/img/100x100/dark/southbound.png',
				name: 'Southbound curb lane (or right side curb for a one-way)'
			},
			{
				id: 3,
				img: '/img/lcr/eastbound-lane.svg',
				img100: '/img/100x100/dark/eastbound.png',
				name: 'Eastbound median lane (or left side curb for a one-way)'
			},
			{
				id: 6,
				img: '/img/lcr/westbound-lane.svg',
				img100: '/img/100x100/dark/westbound.png',
				name: 'Westbound median lane (or left side curb for a one-way)'
			},
			{
				id: 9,
				img: '/img/lcr/northbound-lane.svg',
				img100: '/img/100x100/dark/northbound.png',
				name: 'Northbound median lane (or left side curb for a one-way)'
			},
			{
				id: 12,
				img: '/img/lcr/southbound-lane.svg',
				img100: '/img/100x100/dark/southbound.png',
				name: 'Southbound median lane (or left side curb for a one-way)'
			}
		];
	}

	static get getAffectBicycleOptions() {
		return [
			{
				name: 'Yes, we will be blocking a painted bike lane',
				id: 1
			},
			{
				name: 'Yes, we will be blocking a protected bike lane ( A protected lane is separated from traffic by either barricades or curbs or both)',
				id: 2
			},
			{
				name: 'No, we will not be blocking any bike lanes',
				id: 3
			}
		];
	}

	// The ids are from the Organization Table.
	static get getMajorUtilitiesOptions() {
		return [
			{
				id: 1,
				name: 'City of Winnipeg'
			},
			{
				id: 7,
				name: 'Manitoba Hydro'
			},
			{
				id: 8,
				name: 'Winnipeg Transit'
			},
			{
				id: 9,
				name: 'Bell MTS'
			},
			{
				id: 10,
				name: 'Shaw'
			},
			{
				id: 11,
				name: 'Telus'
			},
			{
				id: 12,
				name: 'Rogers Communications'
			},
			{
				id: 13,
				name: 'City of Winnipeg Film and Special Events Office'
			},
		];
	}

	static get getThirdPartiesOptions() {
		return [
			{
				id: 5,
				name: 'Pattern Interactive'
			},
			{
				id: 6,
				name: 'Construction Minus'
			},
		];
	}

	static get getWorkDoneForTypeOptions() {
		return [
			{
				name: 'City of Winnipeg / Major Utilities',
				id: 1
			},
			{
				name: 'Third-Party',
				id: 2
			}
		];
	}



	static get getYesNoOptions() {
		return [
			{
				name: 'Yes',
				id: 1
			},
			{
				name: 'No',
				id: 0
			}
		];
	}

	static get getYesNoInsuranceOptions() {
		return [
			{
				name: 'Yes, I have active liability insurance.',
				id: 1
			},
			{
				name: 'No',
				id: 0
			}
		];
	}


	static get getWorkZoneKphOptions() {
		return [
			{
				name: 'Yes, the speed limit is 80 kph or higher',
				id: 80
			},
			{
				name: 'The speed limit is 70 kph',
				id: 70
			},
			{
				name: 'No, the speed limit is 60kph or lower',
				id: 60
			}
		];
	}

	static get getWorkZoneReduceKphOptions() {
		return [
			{
				name: 'Yes',
				id: 60
			},
			{
				name: 'No',
				id: null
			},
		];
	}




	static get getYesNoTransitOptions() {
		return [
			{
				name: 'Yes, I will be affecting Transit',
				id: 1
			},
			{
				name: 'No, I will not be affecting Transit in any way',
				id: 0
			}
		];
	}

	// TODO: should include no-left and no-right turn sign images
	static get getTurningRestrictionOptions() {
		return [
			{
				name: 'No left turns will be allowed',
				id: '1'
			},
			{
				name: 'No right turns will be allowed',
				id: '2'
			},
			{
				name: 'No turns at all will be allowed',
				id: '3'
			},
		];
	}

	static get getClosureTypeFilterOptions() {
		return [
			{
				name: 'Any',
				id: null
			},
			{
				name: 'Directional',
				id: 1
			},
			{
				name: 'Full',
				id: 2
			}
		];
	}

	static get getPeakTimeFilterOptions() {
		return [
			{
				name: 'All',
				id: null
			},
			{
				name: 'Morning (07:00 - 09:00)',
				id: 1
			},
			{
				name: 'Evening (15:00 - 18:00)',
				id: 2
			},
			{
				name: 'Morning & Evening (07:00 - 09:00 & 15:00 - 18:00)',
				id: 3
			},
		];
	}

	static get getSortOptions() {
		return [
			{
				text: 'Sort by Status (Default)',
				value: ''
			},
			{
				text: 'Affected Street A->Z',
				value: 'affectedStreet asc'
			},
			{
				text: 'Affected Street Z->A',
				value: 'affectedStreet desc'
			},
			{
				text: 'Closure Date - Newest First',
				value: 'date desc'
			},
			{
				text: 'Closure Date - Oldest First',
				value: 'date asc'
			},
			{
				text: 'TM # Ascending',
				value: 'idAndRef asc'
			},
			{
				text: 'TM # Descending',
				value: 'idAndRef desc'
			},
			{
				text: 'Created Date - Newest First',
				value: 'createdDate desc'
			},
			{
				text: 'Created Date - Oldest First',
				value: 'createdDate asc'
			},
		]
	}

	static getDirectionText(id) {
		if (id) {
			let txt = this.searchById(id, this.getDirectionIdOptions);
			if (txt) {
				return txt.name;
			}
		}
		return null;
	}

	static getDirectionAbbreviationText(id) {
		if (id) {
			let txt = this.searchById(id, this.getDirectionIdOptions);
			if (txt) {
				return txt.abbrev;
			}
		}
		return null;
	}



	static getLaneInEffectText(val) {
		if (val == 1) {
			return "Closed";
		}
		if (val == 0) {
			return "Open";
		}
		return "Not Reported";
	}

	static getSidewalkInEffectText(val) {
		if (val == 1) {
			return "Closed";
		}
		if (val == 0) {
			return "Open";
		}
		return "Not Reported";
	}

	static getBicycleInEffectText(val) {
		if (val == 1) {
			return "Closed";
		}
		if (val == 0) {
			return "Open";
		}
		return "Not Reported";
	}
	static getRestrictionInEffectText(val) {
		if (val == 1) {
			return "In Place";
		}
		if (val == 0) {
			return "Removed";
		}
		return "Not Reported";
	}

	static getRestrictionDirectionText(id) {
		if (id) {
			return this.searchById(id, this.getRestrictionDirectionIdOptions).name;
		}
		return null;
	}
	static getLanePeakReasonText(peakId) {
		if (peakId) {
			return this.searchByGroupedId(peakId, this.getClosurePeakReason).name;
		}
		return null;
	}
	static getLanePeakReasonTextEffect(peakId) {
		if (peakId) {
			let ef = this.searchByGroupedId(peakId, this.getClosurePeakReason);
			if (ef.effect !== undefined) {
				return ef.effect;
			}
		}
		return null;
	}
	static getLaneText(laneId) {
		if (laneId) {
			return this.searchByGroupedId(laneId, this.getLaneAffectedOptions).name;
		}
		return null;
	}
	static getLaneTextEffect(laneId) {
		if (laneId) {
			return this.searchByGroupedId(laneId, this.getLaneAffectedOptions).effect;
		}
		return null;
	}

	static getLaneTextMultiLine(laneId) {
		if (laneId) {
			var txt = this.searchByGroupedId(laneId, this.getLaneAffectedOptions).name;
			txt = txt.replace("(", "<br/>(");
			return txt;
		}
		return null;
	}


	static getParkingLaneRemovedText(laneId) {
		if (laneId) {
			let entry = this.searchById(laneId, this.getParkingLaneOptions)
			if (entry) {
				return entry.name;
			}
		}
		return null;
	}

	static getTransitText(transitId) {
		if (transitId !== null) {
			let entry = this.searchById(transitId, this.getAffectTransitOptions);
			if (entry) {
				return entry.name;
			}
		}
		return null;
	}

	static getParkingRemovalText(parkingRemovalId) {
		if (parkingRemovalId !== null) {
			let entry = this.searchById(parkingRemovalId, this.getParkingRemoveOptions);
			if (entry) {
				return entry.name;
			}
		}
		return null;
	}
	static getWorkDoneForText(workId) {
		if (workId) {
			let org = this.searchById(workId, LaneClosureRequest.getMajorUtilitiesOptions);
			if (org) {
				return org.name;
			} else {
				org = this.searchById(workId, LaneClosureRequest.getThirdPartiesOptions);
				if (org) {
					return org.name;
				}
			}
		}
		return null;
	}



	static isThirdPartyOrganization(orgId) {
		if (orgId) {
			if (this.searchById(orgId, this.getMajorUtilitiesOptions)) {
				return false;
			}
		}
		return true;
	}


	static getActiveStatusText(id) {
		if (id) {
			return this.searchById(id, this.getActiveStatusIdOptions).name;
		}
		return null;
	}

	static getRecordStatusText(id) {
		if (id) {
			return this.searchById(id, this.getLaneClosureRequestRecordStatusIdOptions).name;
		}
		return null;
	}

	static hasTrafficLaneInDirection(laneId, directionId) {
		let x = 0;

		// since there is no direction set, let's default to allowing them.
		if (directionId == null) {
			return true;
		}
		if (laneId) {
			var options = this.searchByGroupedId(laneId, this.getLaneAffectedOptions);
			for (x = 0; x < options.directionIds.length; x++) {
				if (options.directionIds[x] == directionId) {
					return true;
				}
			}
			return false;
		}
		return false;
	}


	static hasSidewalkInDirection(sidewalkId, directionId) {
		let x = 0;
		if (sidewalkId) {
			var options = this.searchById(sidewalkId, this.getSidewalkOptions);
			for (x = 0; x < options.directionIds.length; x++) {
				if (options.directionIds[x] == directionId) {
					return true;
				}
			}
			return false;
		}
		return false;
	}

	static hasBicycleInDirection(bicycleLaneId, directionId) {
		let x = 0;

		if (bicycleLaneId) {
			var options = this.searchById(bicycleLaneId, this.getBicycleLaneOptions);
			for (x = 0; x < options.directionIds.length; x++) {
				if (options.directionIds[x] == directionId) {
					return true;
				}
			}
			return false;
		}
		return false;
	}


	static getRestrictionTypeText(restrictionTypeId) {
		if (restrictionTypeId) {
			return this.searchById(restrictionTypeId, this.getTurningRestrictionTypeOptions).name;
		}
		return null;
	}

	static getLaneImage(laneId) {
		if (laneId) {
			return this.searchByGroupedId(laneId, this.getLaneAffectedOptions).img;
		}
		return null;
	}
	static getLaneImageLight(laneId) {
		if (laneId) {
			return this.searchByGroupedId(laneId, this.getLaneAffectedOptions).imgLight;
		}
		return null;
	}
	static getLaneImage100(laneId) {
		if (laneId) {
			return this.searchByGroupedId(laneId, this.getLaneAffectedOptions).img100;
		}
		return null;
	}

	static getRestrictionImage(restrictionTypeId) {
		if (restrictionTypeId) {
			return this.searchById(restrictionTypeId, this.getTurningRestrictionTypeOptions).img;
		}
		return null;
	}
	static getRestrictionImageLight(restrictionTypeId) {
		if (restrictionTypeId) {
			return this.searchById(restrictionTypeId, this.getTurningRestrictionTypeOptions).imgLight;
		}
		return null;
	}
	static getRestrictionImage100(restrictionTypeId) {
		if (restrictionTypeId) {
			return this.searchById(restrictionTypeId, this.getTurningRestrictionTypeOptions).img100;
		}
		return null;
	}
	static getRestrictionImageLight100(restrictionTypeId) {
		if (restrictionTypeId) {
			return this.searchById(restrictionTypeId, this.getTurningRestrictionTypeOptions).imgLight100;
		}
		return null;
	}


	static getBicycleLaneImage(laneId) {
		if (laneId) {
			return this.searchById(laneId, this.getBicycleLaneOptions).img;
		}
		return null;
	}
	static getBicycleLaneImageLight(laneId) {
		if (laneId) {
			return this.searchById(laneId, this.getBicycleLaneOptions).imgLight;
		}
		return null;
	}
	static getBicycleLaneImage100(laneId) {
		if (laneId) {
			return this.searchById(laneId, this.getBicycleLaneOptions).img100;
		}
		return null;
	}
	static getBicycleLaneImageLight100(laneId) {
		if (laneId) {
			return this.searchById(laneId, this.getBicycleLaneOptions).imgLight100;
		}
		return null;
	}

	static getSidewalkImage(id) {
		if (id) {
			return this.searchById(id, this.getSidewalkOptions).img;
		}
		return null;
	}
	static getSidewalkImageLight(id) {
		if (id) {
			return this.searchById(id, this.getSidewalkOptions).imgLight;
		}
		return null;
	}
	static getSidewalkImage100(id) {
		if (id) {
			return this.searchById(id, this.getSidewalkOptions).img100;
		}
		return null;
	}
	static getSidewalkImageLight100(id) {
		if (id) {
			return this.searchById(id, this.getSidewalkOptions).imgLight100;
		}
		return null;
	}



	static getLeftTurnSignalText(turn) {
		if (turn !== null) {
			return this.searchById(turn, this.getYesNoOptions).name;
		}
		return "N/A";
	}

	static getYesNoText(val) {
		if (val !== null) {
			return this.searchById(val, this.getYesNoOptions).name;
		}
		return null;
	}

	static getSidewalkText(sidewalkId) {
		if (sidewalkId) {
			return this.searchById(sidewalkId, this.getSidewalkOptions).name;
		}
		return "N/A";
	}
	static getNatureOfWorkText(natureOfWorkId) {
		if (natureOfWorkId) {
			return this.searchById(natureOfWorkId, this.getNatureOfWorkOptions).name;
		}
		return "N/A";
	}
	static getNatureOfWorkTextEffect(natureOfWorkId) {
		if (natureOfWorkId != null) {
			return this.searchById(natureOfWorkId, this.getNatureOfWorkOptions).effect;
		}
		return "N/A";
	}

	static getDczRequiredText(dcz) {
		if (dcz) {
			return this.searchById(dcz, this.getYesNoOptions).name;
		}
		return "N/A";
	}

	static getBicycleLaneText(bicycleId) {
		if (bicycleId) {
			return this.searchById(bicycleId, this.getBicycleLaneOptions).name;
		}
		return "N/A";
	}


	static searchById(nameKey, iArray) {
		for (let i = 0; i < iArray.length; i++) {
			if (iArray[i].id === nameKey) {
				return iArray[i]
			}
		}
	}

	static searchByGroupedId(nameKey, iArray) {
		for (let i = 0; i < iArray.length; i++) {
			if (iArray[i].options) {
				for (let ii = 0; ii < iArray[i].options.length; ii++) {
					if (iArray[i].options[ii].id === nameKey) {
						return iArray[i].options[ii]
					}
				}
			}
		}
		return null;
	}



	constructor(data) {
		let index = 0;
		let x = 0;
		let xx = 0;
		let obj = {};
		let foundUnique = false;

		if (!data) {
			data = {}
		}
		Object.assign(this, {
			id: data.id || null,
			ownerId: data.ownerId || null,
			requesterId: data.requesterId || null,

			requesterProjectId: new BootstrapField({
				value: data.requesterProjectId || null,
			}),
			ownerProjectId: new BootstrapField({
				value: data.ownerProjectId || null,
			}),

			createdDate: data.createdDate || null,
			modifiedDate: data.modifiedDate || null,

			workDoneForId: new BootstrapField({
				value: data.workDoneForId || null,
				required: true,
				fnRawValue: function() {
					if (this.value == null) {
						return null;
					}
					if (this.value.id != null) {
						return this.value.id;
					} else {
						return this.value;
					}
				}
			}),


			workDoneForName: new BootstrapField({
				value: data.workDoneForName || null,
			}),

			workDoneForNamePath: new BootstrapField({
				value: data.workDoneForNamePath || null,
			}),

			lanesClosedSameTime: new BootstrapField({
				value: data.lanesClosedSameTime || null,
				invalidMessage: 'Please enter valid a value. Either No Multiple Lanes Closed, or number of lanes in each direction. ',
				required: false,
			}),


			workDoneForTypePath: new BootstrapField({
				value: data.workDoneForTypePath || null,
			}),

			workDoneForIdPath: new BootstrapField({
				value: data.workDoneForIdPath || null,
			}),

			projectBidNumber: new BootstrapField({
				value: data.projectBidNumber || null,
			}),
			projectTwo: data.projectTwo || null,

			affectedStreet: new BootstrapField({
				value: data.affectedStreet || null,
				required: true,
			}),

			firstCrossStreet: new BootstrapField({
				value: data.firstCrossStreet || null,
				required: true,
			}),
			lastCrossStreet: new BootstrapField({
				value: data.lastCrossStreet || null,
				required: true,
			}),
			isUnderTwoHours: new BootstrapField({
				value: typeof data.isUnderTwoHours === 'number' ? data.isUnderTwoHours : null,
				required: true,
			}),


			fromDate: new BootstrapField({
				value: data.fromDate || null,
				required: true,
				type: BootstrapField.Types.date,
				// validator: function(value) {
				// 	return value instanceof Date;
				// },
				invalidMessage: 'Please enter a valid requested start date',
			}),
			toDate: new BootstrapField({
				value: data.toDate || null,
				required: true,
				type: BootstrapField.Types.date,
				// validator: function(value) {
				// 	return value instanceof Date;
				// },
				invalidMessage: 'Please enter a valid estimated completion date',
			}),
			fromTime: new BootstrapField({
				value: data.fromTime || null,
				type: BootstrapField.Types.date,
				required: true,
				// validator: function(value) {
				// 	return value instanceof Date;
				// },
				// required: true,
				invalidMessage: 'Please enter an estimated start time',
			}),
			toTime: new BootstrapField({
				value: data.toTime || null,
				// required: true,
				type: BootstrapField.Types.date,
				required: true,
				// validator: function(value) {
				// 	return value instanceof Date;
				// },
				invalidMessage: 'Please enter an estimated completion time',
			}),
			numberLanesOpen: new BootstrapField({
				value: data.numberLanesOpen || null,
			}),
			numberLanesClosed: new BootstrapField({
				value: data.numberLanesClosed || null,
			}),
			transitAffected: new BootstrapField({
				value: typeof data.transitAffected === 'number' ? data.transitAffected : null,
				required: true
			}),
			transitBusNumbers: new BootstrapField({
				value: data.transitBusNumbers || null,
			}),
			transitStopNumbers: new BootstrapField({
				value: data.transitStopNumbers || null,
			}),
			transitOther: new BootstrapField({
				value: data.transitOther || null,
			}),
			parkingAffected: new BootstrapField({
				value: typeof data.parkingAffected === 'number' ? data.parkingAffected : null,
			}),

			paidParkingAffected: new BootstrapField({
				value: typeof data.paidParkingAffected === 'number' ? data.paidParkingAffected : null,
				required: true,
				fnRawValue: function() {
					if (this.required) {
						return this.value;
					} else {
						if (this.value == null) {
							return 0; // if its null, return zero.
						}
						return this.value;
					}
				}
			}),

			parkingRemoval : Array.isArray(data.parkingRemoval)
			? data.parkingRemoval.map(item => ({
					id: new BootstrapField({
						value: typeof item.id === 'number' ? item.id : null,
						required: true,
					}),
					parkingLaneId: new BootstrapField({
						value: typeof item.parkingLaneId === 'number' ? item.parkingLaneId : null,
						required: true,
					}),
					parkingRemovalMetres: new BootstrapField({
						value: typeof item.parkingRemovalMetres === 'number' ? item.parkingRemovalMetres : 0,
						type: BootstrapField.Types.number,
						invalidMessage: 'Please enter a number',
					}),
					parkingStartAddress: new BootstrapField({
						value: item.parkingStartAddress || null,
						required: true,
					}),
					parkingEndAddress: new BootstrapField({
						value: item.parkingEndAddress || null,
						required: true,
					}),
				}))
			: [],
			parkingRemovalId: new BootstrapField({
				value: data.parkingRemovalId || null,
				required: true
			}),

			/*
			parkingRemovalMetres: new BootstrapField({
				value: typeof data.parkingRemovalMetres === 'number' ? data.parkingRemovalMetres : null,
				type: BootstrapField.Types.number,
				invalidMessage: "Please enter a number",
				validator: function(value) {
					if (this.required) {
						if (value != null) {
							return value.isNumber();
						}
					}
					return true;
				},
				fnRawValue: function() {
					if (this.required) {
						return this.value;
					} else {
						return null;
					}
				}
			}),

			parkingStartAddress: new BootstrapField({
				value: data.parkingStartAddress || null,
				fnRawValue: function() {
					if (this.required) {
						return this.value;
					} else {
						return null;
					}
				}
			}),

			parkingEndAddress: new BootstrapField({
				value: data.parkingEndAddress || null,
				fnRawValue: function() {
					if (this.required) {
						return this.value;
					} else {
						return null;
					}
				}
			}),

			*/

			// not using the map for parking markers.
			parkingKml: new BootstrapField({
				value: data.parkingKml || null,
			}),

			recordStatusId: new BootstrapField({
				value: typeof data.recordStatusId === 'number' ? data.recordStatusId : null,
			}),

			approvalStatusId: new BootstrapField({
				value: typeof data.approvalStatusId === 'number' ? data.approvalStatusId : null,
			}),

			completeTypeId: new BootstrapField({
				value: typeof data.completeTypeId === 'number' ? data.completeTypeId : null,
			}),
			isEmergency: new BootstrapField({
				value: typeof data.isEmergency === 'number' ? data.isEmergency : null,
				required: true,
			}),

			trafficSignalsAltered: new BootstrapField({
				value: typeof data.trafficSignalsAltered === 'number' ? data.trafficSignalsAltered : null,
			}),

			requesterComments: new BootstrapField({
				value: data.requesterComments,
			}),

			internalComments: new BootstrapField({
				value: data.internalComments,
			}),

			trafficManagementRef: new BootstrapField({
				value: data.trafficManagementRef || null,
			}),

			directionId: new BootstrapField({
				value: data.directionId || null,
				required: true,
			}),
			natureOfWorkId: new BootstrapField({
				value: data.natureOfWorkId || null,
				required: true,
			}),


			noLeftTurns: new BootstrapField({
				value: typeof data.noLeftTurns === 'number' ? data.noLeftTurns : null
			}),
			noRightTurns: new BootstrapField({
				value: typeof data.noRightTurns === 'number' ? data.noRightTurns : null
			}),
			noThrough: new BootstrapField({
				value: typeof data.noThrough === 'number' ? data.noThrough : null
			}),

			restrictionNotes: new BootstrapField({
				value: data.restrictionNotes || null,
			}),

			permitRequired: new BootstrapField({
				value: typeof data.permitRequired === 'number' ? data.permitRequired : null,
			}),

			permitLiabilityInsurance: new BootstrapField({
				value: typeof data.permitLiabilityInsurance === 'number' ? data.permitLiabilityInsurance : null,
			}),

			permitNearestStreetNumber: new BootstrapField({
				value: data.permitNearestStreetNumber || null,
			}),

			permitRoadwayMetres: new BootstrapField({
				value: typeof data.permitRoadwayMetres === 'number' ? data.permitRoadwayMetres : null,
				validator: function(value) {
					if (this.required) {
						if (value != null) {
							return value.isNumber();
						}
					}
					return true;
				},
				fnRawValue: function() {
					let v = parseFloat(this.value);
					if (isNaN(v)) {
						return null;
					}
					return v;
				}

			}),

			permitRoadwayFrom: new BootstrapField({
				value: data.permitRoadwayFrom || null,
			}),

			permitRoadwayTo: new BootstrapField({
				value: data.permitRoadwayTo || null,
			}),

			permitSidewalkFrom: new BootstrapField({
				value: data.permitSidewalkFrom || null,
			}),

			permitSidewalkTo: new BootstrapField({
				value: data.permitSidewalkTo || null,
			}),

			permitSidewalkMetres: new BootstrapField({
				value: typeof data.permitSidewalkMetres === 'number' ? data.permitSidewalkMetres : null,
				validator: function(value) {
					if (this.required) {
						if (value != null) {
							return value.isNumber();
						}
					}
					return true;
				},
				fnRawValue: function() {
					let v = parseFloat(this.value);
					if (isNaN(v)) {
						return null;
					}
					return v;
				}
			}),

			permitRequests: new BootstrapField({
				value: data.permitRequests || null,
			}),

			crossingPermitRequired: new BootstrapField({
				value: typeof data.crossingPermitRequired === 'number' ? data.crossingPermitRequired : null,
			}),

			crossingPermitLocation: new BootstrapField({
				value: data.crossingPermitLocation || null,
			}),

			crossingPermitEquipment: new BootstrapField({
				value: data.crossingPermitEquipment || null,
			}),

			dczRequired: new BootstrapField({
				value: typeof data.dczRequired === 'number' ? data.dczRequired : null,
				invalidMessage: 'Please indicate if the speed limit is over 80 kph in your proposed work zone.'
			}),

			dczLimits: new BootstrapField({
				value: data.dczLimits || null,
			}),

			dczTemporaryTcRemoved: new BootstrapField({
				value: typeof data.dczTemporaryTcRemoved === 'number' ? data.dczTemporaryTcRemoved : null,
			}),

			dczHazards: new BootstrapField({
				value: data.dczHazards || null,
			}),

			dczHoursOfWork: new BootstrapField({
				value: data.dczHoursOfWork || null,
			}),

			wfseoControlCode: new BootstrapField({
				value: data.wfseoControlCode || null,
			}),
			wfseoPermitRequestInfo: new BootstrapField({
				value: data.wfseoPermitRequestInfo || null,
			}),


			closureOwnerId: data.closureOwnerId || null,
			closureReporterId: data.closureReporterId || null,
			restrictionOwnerId: data.restrictionOwnerId || null,
			restrictionReporterId: data.restrictionReporterId || null,

			ownerProjectName: data.ownerProjectName || null,
			requesterProjectName: data.requesterProjectName || null,


			owner: data.owner || null,
			requester: data.requester || null,
			closureOwner: data.closureOwner || null,
			closureReporter: data.closureReporter || null,
			restrictionOwner: data.restrictionOwner || null,
			restrictionReporter: data.restrictionReporter || null,

			// multiple-value attributes
			altRequester: data.altRequester || [],
			altClosureReporter: data.altClosureReporter || [],
			altRestrictionReporter: data.altRestrictionReporter || [],
			attachment: [],
			block: [],
			presetBlock: [],
			message: [],
			contravention: [],
			contact: data.contact || [],
			trafficControlDiagram: data.trafficControlDiagram || [],
			blockLane: data.blockLane || [],
			email: data.email || [],
			geometry: data.geometry || [],
			parkingLane: new BootstrapField({
				value: data.parkingLane || [],
				invalidMessage: 'Please select the parking lane(s) to have parking removed from.',
				fnRawValue: function() {
					if (this.required) {
						return this.value;
					} else {
						return null;
					}
				}
			}),
			parkingLaneGeometry: [],
			sidewalk: new BootstrapField({
				value: data.sidewalk || [],
			}),
			transit: new BootstrapField({
				value: data.transit || [],
			}),

			trafficEffect: new BootstrapField({
				value: data.trafficEffect || null,
			}),

			uniqueLanes: data.uniqueLanes || [],
			uniqueRestrictions: data.uniqueRestrictions || [],


			closureActiveStatusId: new BootstrapField({
				value: data.closureActiveStatusId || null,
			}),

			restrictionActiveStatusId: new BootstrapField({
				value: data.restrictionActiveStatusId || null,
			}),

			workZoneKph: new BootstrapField({
				value: data.workZoneKph || 60, // defaulting to 60 km/h because somehow it becomes null.
				required: true
			}),

			workZoneReduceKph: new BootstrapField({
				value: data.workZoneReduceKph || null,
			}),
			warningMessage: new BootstrapField({
				value: data.warningMessage || null,
			}),

			actAsAca: new BootstrapField({
				value: typeof data.actAsAca === 'number' ? data.actAsAca : null,
				required: true,
			}),

			acaParkingRemoval: new BootstrapField({
				value: typeof data.acaParkingRemoval === 'number' ? data.acaParkingRemoval : null,
				required: false,
			}),
			acaTurnRestrictions: new BootstrapField({
				value: typeof data.acaTurnRestrictions === 'number' ? data.acaTurnRestrictions : null,
				required: false,
			}),
			acaFullDirectional: new BootstrapField({
				value: typeof data.acaFullDirectional === 'number' ? data.acaFullDirectional : null,
				required: false,
			}),
			acaDcz: new BootstrapField({
				value: typeof data.acaDcz === 'number' ? data.acaDcz : null,
				required: false,
			}),

			displayTime: new BootstrapField({
				value: typeof data.displayTime === 'number' ? data.displayTime : null,
			}),

			bidAdmin: new BootstrapField({
				value: data.bidAdmin || null,
			}),

			tempTrafficControl: new BootstrapField({
				value: typeof data.tempTrafficControl === 'number' ? data.tempTrafficControl : null,
				required: true,
				invalidMessage: 'Please select if Traffic Services needs to complete traffic control for you.',
			}),

			conflicts: data.conflicts || null,
			notification: data.notification || null,

			isDirtyFlag: false,
		});

		this.isDirty = function() {
			return this.isDirtyFlag;
		}
		this.setDirty = function() {
			this.isDirtyFlag = true;
		}
		this.setClean = function() {
			this.isDirtyFlag = false;
		}

		this.workDoneForId.isCityOfWinnipeg = function() {
			if (this.value != null) {
				if (this.value.idPath) {
					if (this.value.idPath.indexOf("|1|") > -1) {
						return true;
					}
				}
			}
			return false;
		}
		this.workDoneForId.isCoWFSEO = function() {
			if (this.value != null) {
				if (this.value.idPath) {
					if (this.value.idPath.indexOf("|13|") > -1) {
						return true;
					}
				}
			}
			return false;
		}
		this.workDoneForId.isAgency = function() {
			if (this.value != null) {
				if (this.value.organizationTypeId) {
					if (this.value.organizationTypeId == "agency") {
						return true;
					}
				}
			}
			return false;
		}




		this.workDoneForIdPath.isCityOfWinnipeg = function() {
			if (this.value != null) {
				if (this.value) {
					if (this.value.indexOf("|1|") > -1) {
						return true;
					}
				}
			}
			return false;
		}
		this.workDoneForIdPath.isCoWFSEO = function() {
			if (this.value != null) {
				if (this.value) {
					if (this.value.indexOf("|13|") > -1) {
						return true;
					}
				}
			}
			return false;
		}


		if (data.block instanceof Array) {
			let x = 0;
			for (x = 0; x < data.block.length; x++) {
				this.block.push(new LaneClosureRequestBlock(data.block[x]));
			}
		}

		// presets are very similar
		if (data.presetBlock instanceof Array) {
			let x = 0;
			for (x = 0; x < data.presetBlock.length; x++) {
				this.presetBlock.push(new LaneClosureRequestPresetBlock(data.presetBlock[x]));
			}
		} else {
			// put in a default preset...
			this.presetBlock.push(new LaneClosureRequestPresetBlock());
		}



		// set the expanded traffic signal altered flag.
		this.presetBlock[0].expandTrafficSignalsAltered = false;

		if (data.message instanceof Array) {
			let x = 0;
			for (x = 0; x < data.message.length; x++) {
				this.message.push(new LaneClosureRequestMessage(data.message[x]));
			}
		}

		if (data.attachment instanceof Array) {
			let x = 0;
			for (x = 0; x < data.attachment.length; x++) {
				this.attachment.push(new Attachment(data.attachment[x]));
			}
		}
		if (data.contravention instanceof Array) {
			let x = 0;
			for (x = 0; x < data.contravention.length; x++) {
				this.contravention.push(new Contravention(data.contravention[x]));
			}
		}

		// now add missing preset blocks based on the lane closure request data...
		if (this.block) {

			for (index = 0; index < this.block.length; index++) {
				for (x = 0; x < this.block[index].lane.length; x++) {
					obj = {
						lanesClosedSameTime: this.lanesClosedSameTime.value,
						trafficSignalsAltered: this.trafficSignalsAltered.value,
						laneId: this.block[index].lane[x].laneId.value,
						peakId: this.block[index].lane[x].peakId.value,
						peakReason: this.block[index].lane[x].peakReason.value
					}
					foundUnique = false;
					for (xx = 0; xx < this.presetBlock[0].lane.length; xx++) {
						if (
							this.block[index].lane[x].laneId.value == this.presetBlock[0].lane[xx].laneId.value &&
							this.block[index].lane[x].peakId.value == this.presetBlock[0].lane[xx].peakId.value
						) {
							foundUnique = true;
							break;
						}
					}
					if (!foundUnique) {
						this.presetBlock[0].lane.push(new LaneClosureRequestPresetLane(obj));
					}
				}
			}
			foundUnique = false;
			for (index = 0; index < this.block.length; index++) {
				for (x = 0; x < this.block[index].sidewalk.length; x++) {
					obj = {
						sidewalkId: this.block[index].sidewalk[x].sidewalkId.value,
					}
					foundUnique = false;
					for (xx = 0; xx < this.presetBlock[0].sidewalk.length; xx++) {
						if (
							this.block[index].sidewalk[x].sidewalkId.value == this.presetBlock[0].sidewalk[xx].sidewalkId.value
						) {
							foundUnique = true;
							break;
						}
					}
					if (!foundUnique) {
						this.presetBlock[0].sidewalk.push(new LaneClosureRequestPresetSidewalk(obj));
					}
				}
			}

			for (index = 0; index < this.block.length; index++) {
				for (x = 0; x < this.block[index].bicycle.length; x++) {
					obj = {
						bicycleLaneId: this.block[index].bicycle[x].bicycleLaneId.value,
					}
					foundUnique = false;
					for (xx = 0; xx < this.presetBlock[0].bicycle.length; xx++) {
						if (
							this.block[index].bicycle[x].bicycleLaneId.value == this.presetBlock[0].bicycle[xx].bicycleLaneId.value
						) {
							foundUnique = true;
							break;
						}
					}
					if (!foundUnique) {
						this.presetBlock[0].bicycle.push(new LaneClosureRequestPresetBicycle(obj));
					}
				}
			}


			// var foundStreet = false;
			var y = 0;
			for (index = 0; index < this.block.length; index++) {
				if (this.block[index].restriction) {
					for (x = 0; x < this.block[index].restriction.length; x++) {
						obj = {
							directionId: this.block[index].restriction[x].directionId.value,
							restrictionTypeId: this.block[index].restriction[x].restrictionTypeId.value,
							peakId: this.block[index].restriction[x].peakId.value,
							peakReason: this.block[index].restriction[x].peakReason.value
						}
						foundUnique = -1;
						for (xx = 0; xx < this.presetBlock[0].restriction.length; xx++) {
							if (
								this.block[index].restriction[x].restrictionTypeId.value == this.presetBlock[0].restriction[xx].restrictionTypeId.value &&
								this.block[index].restriction[x].directionId.value == this.presetBlock[0].restriction[xx].directionId.value &&
								this.block[index].restriction[x].peakId.value == this.presetBlock[0].restriction[xx].peakId.value
							) {
								foundUnique = xx;

							}
						}
						if (foundUnique == -1) {
							this.presetBlock[0].restriction.push(new LaneClosureRequestPresetRestriction(obj));
							foundUnique = this.presetBlock[0].restriction.length - 1;
						}
						// push this block's chosen street names into the preset block...
						if (typeof this.presetBlock[0].restriction[foundUnique].turningStreetName["b" + this.block[index].blockId] == "undefined") {
							this.presetBlock[0].restriction[foundUnique].turningStreetName["b" + this.block[index].blockId] = [];
						}
						if (this.presetBlock[0].restriction[foundUnique].turningStreetName["b" + this.block[index].blockId].indexOf(this.block[index].restriction[x].crossStreet.value) == -1) {
							this.presetBlock[0].restriction[foundUnique].turningStreetName["b" + this.block[index].blockId].push(this.block[index].restriction[x].crossStreet.value);
						}

						// push this block's chosen street names into the preset block...
						if (typeof this.presetBlock[0].restriction[foundUnique].turningStreetName["b" + this.block[index].blockId] == "undefined") {
							this.presetBlock[0].restriction[foundUnique].turningStreetName["b" + this.block[index].blockId] = [];
						}
						if (this.presetBlock[0].restriction[foundUnique].turningStreetName["b" + this.block[index].blockId].indexOf(this.block[index].restriction[x].crossStreet.value) == -1) {
							this.presetBlock[0].restriction[foundUnique].turningStreetName["b" + this.block[index].blockId].push(this.block[index].restriction[x].crossStreet.value);
						}
						for (y = 0; y < this.block[index].turningStreetName.length; y++) {
							if (this.presetBlock[0].restriction[foundUnique].turningStreetName["b" + this.block[index].blockId].indexOf(this.block[index].turningStreetName[y]) == -1) {
								this.presetBlock[0].restriction[foundUnique].turningStreetName["b" + this.block[index].blockId].push(this.block[index].turningStreetName[y]);
							}
						}
						// add the block turning entries too...
						if (this.presetBlock[0].restriction[foundUnique].turningStreetName["b" + this.block[index].blockId].indexOf(this.block[index].northboundLeft) == -1) {
							this.presetBlock[0].restriction[foundUnique].turningStreetName["b" + this.block[index].blockId].push(this.block[index].northboundLeft);
						}
						if (this.presetBlock[0].restriction[foundUnique].turningStreetName["b" + this.block[index].blockId].indexOf(this.block[index].northboundRight) == -1) {
							this.presetBlock[0].restriction[foundUnique].turningStreetName["b" + this.block[index].blockId].push(this.block[index].northboundRight);
						}
						if (this.presetBlock[0].restriction[foundUnique].turningStreetName["b" + this.block[index].blockId].indexOf(this.block[index].southboundLeft) == -1) {
							this.presetBlock[0].restriction[foundUnique].turningStreetName["b" + this.block[index].blockId].push(this.block[index].southboundLeft);
						}
						if (this.presetBlock[0].restriction[foundUnique].turningStreetName["b" + this.block[index].blockId].indexOf(this.block[index].southboundRight) == -1) {
							this.presetBlock[0].restriction[foundUnique].turningStreetName["b" + this.block[index].blockId].push(this.block[index].southboundRight);
						}
						if (this.presetBlock[0].restriction[foundUnique].turningStreetName["b" + this.block[index].blockId].indexOf(this.block[index].eastboundLeft) == -1) {
							this.presetBlock[0].restriction[foundUnique].turningStreetName["b" + this.block[index].blockId].push(this.block[index].eastboundLeft);
						}
						if (this.presetBlock[0].restriction[foundUnique].turningStreetName["b" + this.block[index].blockId].indexOf(this.block[index].eastboundRight) == -1) {
							this.presetBlock[0].restriction[foundUnique].turningStreetName["b" + this.block[index].blockId].push(this.block[index].eastboundRight);
						}
						if (this.presetBlock[0].restriction[foundUnique].turningStreetName["b" + this.block[index].blockId].indexOf(this.block[index].westboundLeft) == -1) {
							this.presetBlock[0].restriction[foundUnique].turningStreetName["b" + this.block[index].blockId].push(this.block[index].westboundLeft);
						}
						if (this.presetBlock[0].restriction[foundUnique].turningStreetName["b" + this.block[index].blockId].indexOf(this.block[index].westboundRight) == -1) {
							this.presetBlock[0].restriction[foundUnique].turningStreetName["b" + this.block[index].blockId].push(this.block[index].westboundRight);
						}

					}
				}
			}

		}


		// Keep a record of the old data. (used for the hasChanges() method)
		// originalLaneClosureRequestData = CloneDeep(this);
		originalLaneClosureRequestData = this.getRawValue();
	}

	validate() {

		this.toTime.invalidMessage = 'Please enter a valid end time';
		this.toDate.invalidMessage = 'Please enter a valid estimated completion date';
		let flag = true;

		let errors = [];

		for (let field in this) {
			if (this[field] instanceof BootstrapField) {
				let result = this[field].validate();
				if (result === false) {
					errors.push(field);
					flag = false;
				}
			}
		}
		return flag;
	}

	getRawValue() {
		return getRawValue(this);

		function getRawValue(obj) {
			let value = {};
			if (obj instanceof BootstrapField) {
				value = obj.getRawValue();
			} else if (obj instanceof Object && Object.keys(obj).length > 0) {
				for (let key in obj) {
					if (obj[key] instanceof Array) {
						value[key] = [];
						for (let arrKey in obj[key]) {
							if (typeof obj[key][arrKey] != "function") {
								value[key].push(getRawValue(obj[key][arrKey]));
							}
						}
					} else {
						if (key == "mapPolyline") {
							value[key] = null;
						} else {
							if (typeof value[key] != "function") {
								if (obj instanceof LaneClosureRequestBlock && key == "sRoute") {
									// we won't be submitting sRoute...
								} else {
									value[key] = getRawValue(obj[key]);
								}
							}
						}
					}
				}
			} else if (obj instanceof Array && obj.length > 0) {
				// This shouldnt ever run, as an array is also an object.
			}
			// Default, just return the value;
			else {
				value = obj;
			}
			return value;
		}
	}

	getValue() {
		return getValue(this);

		function getValue(obj) {
			let value = {};
			if (obj instanceof BootstrapField) {
				value = obj.getValue();
			} else if (obj instanceof Object && Object.keys(obj).length > 0) {
				for (let key in obj) {
					if (obj[key] instanceof Array) {
						value[key] = [];
						for (let arrKey in obj[key]) {
							value[key].push(getValue(obj[key][arrKey]));
						}
					} else {
						if (key == "mapPolyline") {
							value[key] = null;
						} else {
							if (typeof value[key] != "function") {
								value[key] = getValue(obj[key]);
							}
						}
					}
				}
			} else if (obj instanceof Array && obj.length > 0) {
				// This shouldnt ever run, as an array is also an object.
			}
			// Default, just return the value;
			else {
				value = obj;
			}
			return value;
		}
	}


	hasChanges() {
		return !IsEqual(originalLaneClosureRequestData, this.getRawValue());
	}
	revertChanges() {
		this.constructor(originalLaneClosureRequestData);
	}
	saveChanges() {
		// originalLaneClosureRequestData = CloneDeep(this);
		originalLaneClosureRequestData = this.getRawValue();
	}

	static get calculateLcrTrafficEffectText() {
		let effect = "";

		if (this.affectedStreet.value) {
			effect += this.affectedStreet.value + " ";
		}
		if (this.directionId.value) {
			effect += this.getDirectionText(this.directionId.value);
		}
		effect += ", ";

		if (this.fromStreet.value) {
			effect += this.fromStreet.value + " ";
			effect += " to ";
		}
		if (this.toStreet.value) {
			effect += this.toStreet.value + " ";
		}

		// get each block set...
		if (this.presetBlock) {
			for (let x = 0; x < this.presetBlock[0].lane.length; x++) {
				effect += ", " + this.getLaneText(this.presetBlock[0].lane[x].value);
			}

			for (let x = 0; x < this.presetBlock[0].bicycle.length; x++) {
				effect += ", " + this.getBicycleLaneText(this.presetBlock[0].bicycle[x].value);
			}

			for (let x = 0; x < this.presetBlock[0].sidewalk.length; x++) {
				effect += ", " + this.getSidewalkText(this.presetBlock[0].sidewalk[x].value);
			}
		}
		if (this.toStreet.value) {
			effect += ", " + this.getNatureOfWorkText(this.natureOfWorkId.value);
		}

		return effect;
	}



}